module.exports = __webpack_public_path__ + "img/bitget.e6c58a1d.svg";